// @ts-ignore
/* eslint-disable */
import type { CustomRequestOptions } from '../customRequestOptions';
import { request } from '../axios/mchTradeData';

/** 查询首页当天全部门店列表 POST /pc/b/index/dashboard/statement/shop/today/rank/all */
export async function rankAll(
  body: APIMchTradeData.QryIndexTodayShopRankRequest,
  options?: CustomRequestOptions,
) {
  return request<APIMchTradeData.ListResponseBpIndexShopTopDto_>(
    '/pc/b/index/dashboard/statement/shop/today/rank/all',
    {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      data: body,
      ...(options || {}),
    },
  );
}

/** 查询首页当天排名前N门店列表计 POST /pc/b/index/dashboard/statement/shop/today/rank/topN */
export async function rankTopN(
  body: APIMchTradeData.QryIndexTodayShopRankRequest,
  options?: CustomRequestOptions,
) {
  return request<APIMchTradeData.ListResponseBpIndexShopTopDto_>(
    '/pc/b/index/dashboard/statement/shop/today/rank/topN',
    {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      data: body,
      ...(options || {}),
    },
  );
}

/** 查询当天交易日期最近N天的数据(近N日交易) POST /pc/b/index/dashboard/statement/trade/today/nearest */
export async function todayNearest(
  body: APIMchTradeData.QryTradeTodayStatRequest,
  options?: CustomRequestOptions,
) {
  return request<APIMchTradeData.ListResponseBpIndexBusinessTrendStatDataDto_>(
    '/pc/b/index/dashboard/statement/trade/today/nearest',
    {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      data: body,
      ...(options || {}),
    },
  );
}

/** 查询当天交易数据概览(今日数据概览) POST /pc/b/index/dashboard/statement/trade/today/overview */
export async function todayOverview(
  body: APIMchTradeData.QryTradeTodayStatRequest,
  options?: CustomRequestOptions,
) {
  return request<APIMchTradeData.CommonResponseBpIndexStatOverviewDto_>(
    '/pc/b/index/dashboard/statement/trade/today/overview',
    {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      data: body,
      ...(options || {}),
    },
  );
}

/** 查询当天交易基于支付类型的日统计(渠道交易占比) POST /pc/b/index/dashboard/statement/trade/today/payType */
export async function todayPayType(
  body: APIMchTradeData.QryTradeTodayStatRequest,
  options?: CustomRequestOptions,
) {
  return request<APIMchTradeData.ListResponseBpPayTypeStatDto_>(
    '/pc/b/index/dashboard/statement/trade/today/payType',
    {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      data: body,
      ...(options || {}),
    },
  );
}
